<template>
  <div class="container">
    <div class="pay">
      <div class="pay__item pay__main">
        <div class="pay__header">
          <img src="@/assets/images/logo_white.svg" alt="FHS Logo" />
        </div>
        <div class="pay__body">
          <div class="pay__order-info">
            <h3 class="pay__heading">Информация о заказе</h3>
            <div class="pay__bill bill shadow-container">
              <div class="bill__row">
                <p class="bill__text">Сумма к оплате</p>
                <p class="bill__text">0 ₸</p>
              </div>
              <div class="bill__row">
                <p class="bill__text">Продавец</p>
                <p class="bill__text">FHS</p>
              </div>
              <div class="bill__row">
                <p class="bill__text">Номер заказа</p>
                <p class="bill__text">433644112</p>
              </div>
            </div>
          </div>
          <div class="pay__card-info">
            <h3 class="pay__heading">Информация о карте</h3>
            <div class="pay__info-body shadow-container">
              <div class="pay__input-field">
                <label for="card_number" class="pay__label">Номер карты</label>
                <input
                  type="text"
                  class="pay__input"
                  id="card_number"
                  placeholder="×××× ×××× ×××× ××××"
                />
              </div>
              <div class="pay__input-field">
                <label for="card_number" class="pay__label">Имя на карте</label>
                <input
                  type="text"
                  class="pay__input"
                  id="card_name"
                  placeholder="IVAN IVANOV"
                />
              </div>
            </div>
          </div>
          <div class="pay__extra-info">
            <h3 class="pay__heading">Дополнительная информация</h3>
            <div class="pay__extra-info-body">
              <div class="pay__input-field">
                <label for="card_number" class="pay__label"
                  >Электронная почта</label
                >
                <input
                  type="email"
                  class="pay__input"
                  id="email"
                  placeholder="help@fhs.kz"
                />
              </div>
              <div class="pay__input-field">
                <label for="card_number" class="pay__label">Телефон</label>
                <input
                  type="tel"
                  class="pay__input"
                  id="phone"
                  placeholder="+7 777 123-45-67"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="pay__footer footer">
          <router-link to="/finance" class="footer__button button filled"
            >Оплатить</router-link
          >
          <router-link to="/finance" class="footer__back-link"
            >← Вернуться на сайт</router-link
          >
        </div>
      </div>
      <div class="pay__item pay__info info">
        <div class="info__item">
          <h5 class="info__heading">Платёжный сервис</h5>
          <img
            src="@/assets/images/ePay_logo.svg"
            alt="ePay Logo"
            class="info__image"
          />
        </div>
        <div class="info__item">
          <h5 class="info__heading">Принимаем к оплате карты</h5>
          <div class="row align-center">
            <img
              src="@/assets/images/visa_logo.svg"
              alt="ePay Logo"
              class="info__image"
            />
            <img
              src="@/assets/images/visa_electron_logo.svg"
              alt="ePay Logo"
              class="info__image"
            />
            <img
              src="@/assets/images/mastercard_logo.svg"
              alt="ePay Logo"
              class="info__image"
            />
            <img
              src="@/assets/images/maestro_logo.svg"
              alt="ePay Logo"
              class="info__image"
            />
            <img
              src="@/assets/images/amex_logo.svg"
              alt="ePay Logo"
              class="info__image"
            />
          </div>
        </div>
        <h4 class="info__item info__text">
          После оплаты картой, обязательно дождитесь ответа сервера
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  background-color: #f8f8f8;
}

.pay {
  width: 70%;
  height: 100vh;
  margin: auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.pay__item {
  width: 50%;
  box-sizing: border-box;
}

.pay__main {
  border-radius: 15px;
  box-shadow: 0 2px 15px 0 rgba(213, 213, 213, 0.5);
}

.pay__header {
  padding: 30px 0 30px 40px;
  background-color: #222c44;
  border-radius: 15px 15px 0 0;
}

.pay__heading {
  font-size: 18px;
  font-weight: bold;
}

.pay__body {
  padding: 20px 40px 30px;
  background-color: #ffffff;
}

.pay__bill {
  margin: 20px auto 0;
}

.shadow-container {
  padding: 25px 20px;
  box-shadow: 0 2px 15px 0 rgba(213, 213, 213, 0.5);
}

.bill__row {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.bill__row:not(:first-child) {
  margin-top: 16px;
}

.pay__card-info {
  margin: 30px 0 0;
}

.pay__info-body {
  margin: 20px 0 0;
}

.pay__input-field {
  display: flex;
  flex-direction: column;
}

.pay__input {
  max-width: 280px;
  margin-top: 5px;
  padding: 10px;
  border: 1px solid #d8d8d8;
  outline: none;
}

.pay__input-field:not(:first-child) {
  margin-top: 10px;
}

.pay__extra-info {
  margin: 30px 0;
}

.pay__extra-info-body {
  margin-top: 20px;
}

.footer {
  padding: 20px 0 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  border-radius: 0 0 15px 15px;
}

.footer__button {
  padding: 15px 0;
  min-width: 248px;
  text-transform: uppercase;
  font-size: 17px;
}

.footer__back-link {
  margin-top: 15px;
  text-decoration: none;
  color: #a3a3a3;
  font-size: 13px;
}

.info {
  padding: 24px 40px;
  align-self: flex-start;
}

.info__item:not(:first-child) {
  margin-top: 30px;
}

.info__heading {
  font-size: 17px;
  font-weight: normal;
  color: #a3a3a3;
}

.info__image {
  margin: 11px 11px 0 0;
}

.info__text {
  max-width: 305px;
  font-size: 17px;
  font-weight: normal;
}
</style>
